import WithingsLogoImg from "@/assets/withings-logo.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const WithingsLogo = (props: Props) => (
  <LogoImage imgSrc={WithingsLogoImg} alt="Withings Logo" size="navbar" {...props} />
);
